import { createEnv } from "@t3-oss/env-core";
import zod from "zod";

export const env = createEnv({
  server: {
    SERVER_URL: zod.string().url().optional(),
  },

  clientPrefix: "VITE_",

  client: {
    VITE_DISCORD_URL: zod.string().url(),
    VITE_SUPABASE_URL: zod.string().url(),
    VITE_SUPABASE_ANON_KEY: zod.string().min(1),
    VITE_BASENAME: zod.string().optional(),
    VITE_GTM_ID: zod.string().optional(),
    VITE_SENTRY_ENABLED: zod.string().optional(),
    VITE_SENTRY_DSN: zod.string().url().optional(),
    VITE_RELEASE_ID: zod.string().optional(),
    VITE_RELEASE_DEPLOY_ENVIRONMENT: zod.string().optional(),
  },

  runtimeEnv: import.meta.env,

  emptyStringAsUndefined: true,
});
